import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AccountService } from '../../../services/account.service';
import { SCAMP_API } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { EncarregadoCB } from 'src/app/models/encarregadoCB.model';
import { Funcionario } from 'src/app/models/funcionario.model';

@Injectable({providedIn: 'root'})
export class FuncionarioService {

    constructor(
        private http: HttpClient,
        private account: AccountService
    ) { }

    getEncarregados(): Observable<EncarregadoCB[]> {
        return this.http.get<EncarregadoCB[]>(`${SCAMP_API.accountApiV1}/encarregados`, {headers : this.account.composeHeaders()});
    }

    getEncarregadosPorEmpreiteira(empreiteiraId: number): Observable<EncarregadoCB[]> {
        return this.http.get<EncarregadoCB[]>(`${SCAMP_API.accountApiV1}/encarregados-por-empreiteira/${empreiteiraId}`,
        {headers : this.account.composeHeaders()});
    }

    getFuncionarios(): Observable<Funcionario[]> {
        return this.http.get<Funcionario[]>(`${SCAMP_API.accountApiV1}/funcionarios`,
        {headers : this.account.composeHeaders()});
    }

    getEngenheiros(): Observable<Funcionario[]> {
        return this.http.get<Funcionario[]>(`${SCAMP_API.accountApiV1}/engenheiros`, {headers : this.account.composeHeaders()});
    }

    getEngenheirosPorEmpreiteira(empreiteiraId: number): Observable<Funcionario[]> {
        return this.http.get<Funcionario[]>(`${SCAMP_API.accountApiV1}/engenheiros-por-empreiteira/${empreiteiraId}`,
        {headers : this.account.composeHeaders()});
    }

    getListaFuncionarios(): Observable<Funcionario[]> {
        return this.http.get<Funcionario[]>(`${SCAMP_API.accountApiV1}/lista-funcionarios`,
        {headers : this.account.composeHeaders()});
    }

    getListaFuncionariosPorEmpreteira(id: number): Observable<Funcionario[]> {
        return this.http.get<Funcionario[]>(`${SCAMP_API.accountApiV1}/funcionarios-por-empreiteira/${id}`,
        {headers : this.account.composeHeaders()});
    }


    create(data: any)  {
        return this.http.post(`${SCAMP_API.accountApiV1}/funcionario`, data, {headers : this.account.composeHeaders()});
    }

    read(id: number): Observable<any> {
        return this.http.get<any>(`${SCAMP_API.accountApiV1}/funcionario/${id}`, {headers : this.account.composeHeaders()});
    }

    update(id: number, data: any) {
        return this.http.put(`${SCAMP_API.accountApiV1}/funcionario/${id}`, data, {headers : this.account.composeHeaders()});
    }

    delete(id: number) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/funcionario/${id}`, {headers : this.account.composeHeaders()});
    }

    getAll(): Observable<any[]> {
        return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/lista-funcionarios`, {headers : this.account.composeHeaders()});
    }

    isUniqueMatriculaFuncionario(matricula: string): Observable<boolean> {
        return this.http.post<boolean>(`${SCAMP_API.accountApiV1}/matricula-funcionario-is-unique`, {matricula},
        {headers : this.account.composeHeaders()});
    }

    search(parametro: string): Observable<any[]> {
        return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/funcionarios-search/${parametro}`,
        {headers : this.account.composeHeaders()});
    }



}
